
































import { Component, Vue, Watch } from 'vue-property-decorator';
import {AccountInvoiceDataEditModel, CustomerEditModel, RateRuleAmountFilter} from '@/services/api/nswag/stapiclient_generated';
import {stAccountApi, stCustomerApi, stPaymentApi} from '@/services/st-api';
import { UserStore } from '@/store/user-module';
import StRatePicker from '@/components/basic/StRatePicker.vue';
import SlideIn from '@/components/basic/SlideIn.vue';
import StInput2 from '@/components/basic/StInput2.vue';
import StToggle from '@/components/basic/StToggle.vue';
import StTextarea from '@/components/basic/StTextarea.vue';
import { notifySuccess } from '@/utlitities/notifications';
import * as stripe from '@stripe/stripe-js';

@Component({
  components: {
    StTextarea,
    StToggle,
    StInput2,
    SlideIn,
    StRatePicker,
  },
})
export default class EditPaymentData extends Vue {
  private s: stripe.Stripe | null = null;
  private elements!: stripe.StripeElements;
  private id: number = 0;
  private invoiceData: AccountInvoiceDataEditModel = AccountInvoiceDataEditModel.fromJS({ name: '' });
  private loading: boolean = true;
  private listPage: string = 'Payment';
  private confirming: boolean = false;

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: this.listPage });
  }

  async mounted() {
    this.openSlideIn();
    let publicKey = await stPaymentApi.getStripePublicKey();

    this.s = await stripe.loadStripe(publicKey);
    let clientSecret = await stPaymentApi.createSetupIntent();

    const options: stripe.StripeElementsOptions = {
      clientSecret: clientSecret
    };

    this.elements = (this.s as stripe.Stripe).elements(options);
    const paymentElement = this.elements.create('payment');
    paymentElement.mount('#payment-element');
    this.loading = false;
  }


  async confirm() {
    let elem = this.elements;
    this.confirming = true;
    const { error } = await (this.s as stripe.Stripe).confirmSetup({
      //`Elements` instance that was used to create the Payment Element
      elements: this.elements,
      confirmParams: {
        return_url: window.location.origin + '/paymentdone',
      },
    });

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (e.g., payment
      // details incomplete)
      const messageContainer: Element = document.querySelector('#error-message') as Element;
      messageContainer.textContent = error.message as string;
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }

    this.confirming = false;
  }
}
